// extracted by mini-css-extract-plugin
module.exports = {"form":"index_form_d7afc","btn":"index_btn_2nVfQ"};